import React, { ReactNode } from 'react';
import cx from 'classnames';
import { ELSIcon } from '../els.components';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayoutModifier } from '../flex/flex.constants';

type PageHeaderProps = {
  onCloseClick: (e: React.SyntheticEvent) => void;
  title: string;
  titleClass?: string;
  logo?: { prefix: string; name: string; size: string } | null;
  closeButtonText?: string;
  children?: ReactNode;
}

const PageHeader = (props: PageHeaderProps): JSX.Element => {
  const {
    onCloseClick,
    title,
    titleClass,
    logo,
    closeButtonText,
    children
  } = props;

  return (
    <div className="c-els-page-header">
      <FlexLayout
        classes={['c-els-page-header__container']}
        modifiers={[FlexLayoutModifier.GUTTERS_2X, FlexLayoutModifier.MIDDLE]}>
        <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
          <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS, FlexLayoutModifier.MIDDLE]}>
            <FlexItem>
              <button
                className="c-els-page-header__close-trigger u-els-debuttonize u-els-anchorize"
                type="button"
                onClick={onCloseClick}
              >
                <ELSIcon
                  name="close"
                  size="1x"
                />
                <span className="u-els-hide-visually">{closeButtonText || 'Close'}</span>
              </button>
            </FlexItem>
            {logo && (
              <FlexItem>
                <ELSIcon
                  prefix={logo.prefix}
                  name={logo.name}
                  size={logo.size}
                />
              </FlexItem>
            )}
            <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
              <span className={cx('c-els-page-header__title', titleClass)}>{title}</span>
            </FlexItem>
          </FlexLayout>
        </FlexItem>
        {children && (
          <FlexItem>
            {children}
          </FlexItem>
        )}
      </FlexLayout>
    </div>
  );
};

export default PageHeader;
